import { jsx as _jsx } from "react/jsx-runtime";
import { Clock } from "@air/next-icons";
import { formatDuration } from "@air/utilities";
import { memo } from "react";
import { DiscussionMetadata } from "~/components/Discussions/Discussion/DiscussionComment/components/DiscussionMetadata";
export const CommentTimestampInfo = /*#__PURE__*/ memo((param)=>{
    let { timestamp } = param;
    return /*#__PURE__*/ _jsx(DiscussionMetadata, {
        Icon: Clock,
        text: formatDuration(Math.round(timestamp))
    });
});
CommentTimestampInfo.displayName = "CommentTimestampInfo";
